import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import "./Auth.css";
import Logo from "../../asset/logo.jpg";

function SignupVerify() {
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  // Format mobile like 98765 43210
  const formatMobile = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 10);

    if (digits.length <= 5) return digits;
    return digits.slice(0, 5) + " " + digits.slice(5);
  };

  // Handle typing
  const handleMobileChange = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 10);
    setMobile(digits);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (mobile.length !== 10) {
      setError("Enter valid 10 digit mobile number");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await axiosInstance.post("/accounts/signup/", {
        name,
        mobile,
        password,
      });

      navigate("/login");
    } catch (err) {
      setError(err.response?.data?.detail || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">

        <div className="auth-logo">
          <img src={Logo} alt="Logo" />
        </div>

        <h2>Create Account</h2>
        <p className="auth-subtitle">Sign up to get started</p>

        {error && <p className="auth-error">{error}</p>}

        <form onSubmit={handleSubmit}>

          <div className="input-group">
            <input
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <label>Full Name</label>
            <span className="input-line"></span>
          </div>

          {/* Mobile Input */}
          <div className="input-group phone-group">

            <span className="country-code">+91</span>

            <input
              type="tel"
              required
              value={formatMobile(mobile)}
              onChange={(e) => handleMobileChange(e.target.value)}
            />

            <label>Mobile Number</label>
            <span className="input-line"></span>

          </div>

          <div className="input-group">
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <label>Password</label>
            <span className="input-line"></span>
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Creating..." : "Create Account"}
          </button>

        </form>

      </div>
    </div>
  );
}

export default SignupVerify;